// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
// import { dispatch } from 'react-hot-toast/dist/core/store'

export const getAllData = createAsyncThunk('appTiposCuotas/getAllData', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias`)
  return response.data.data
  // const data = []
  // return data
})

export const getData = createAsyncThunk('appTiposCuotas/getData', async param => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias`, { params: param })
  return {
  param,
  data: response.data.data,
  totalPages: response.data.total}
})


export const getTipoCuota = createAsyncThunk('appTiposCuotas/getTipoCuota', async id => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias/${id}`)
  return response.data.data
})

export const addTipoCuota = createAsyncThunk('appTiposCuotas/addTipoCuota', async (TipoCuota, { dispatch, getState }) => {
  const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias/crear`, TipoCuota)
  await dispatch(getData(getState().tiposCuotas.params))
  //await dispatch(getAllData())
  return response.data
})

export const deleteTipoCuota = createAsyncThunk('appTiposCuotas/deleteTipoCuota', async (id, { dispatch, getState }) => {
  const response = await axios.delete(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias/${id}`)
  await dispatch(getData(getState().tiposCuotas.params))
  //await dispatch(getAllData())
  return response.data
})

export const saveTipoCuota = createAsyncThunk('appTiposCuotas/saveTipoCuota', async (TipoCuota, { dispatch, getState }) => {
  const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias`, TipoCuota)
  await dispatch(getData(getState().tiposCuotas.params))
  //await dispatch(getAllData())
  return response.data
})

export const downloadExcel = createAsyncThunk('appTiposCuotas/downloadExcel', async param => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias/excel`, { params: param })
  return response
})

export const getTiposTransferencia = createAsyncThunk('appTiposCuotas/getTiposTransferencia', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/TiposTransferencias`)
  return response.data.data
})

export const getItemsGasto = createAsyncThunk('appTiposCuotas/getItemsGasto', async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/ItemsGasto`)
  return response.data.data
})

export const appTiposCuotasSlice = createSlice({
  name: 'appTiposCuotas',
  initialState: {
    data: [],
    total: '',
    params: {},
    allData: [],
    provincias: [],
    regiones: [],
    selectedTipoCuota: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.param
        state.total = action.payload.totalPages
      })
      .addCase(getTipoCuota.fulfilled, (state, action) => {
        state.selectedTipoCuota = action.payload
      })
  }
})

export default appTiposCuotasSlice.reducer
